module.exports = __webpack_public_path__ + "img/check_bg.52f40c75.png";